<template>
  <el-form :model="deviceParams" :rules="rules" ref="deviceForm" size="small" label-width="120px" class="deviceForm">
    <el-form-item label="设备名称" prop="deviceName">
      <el-input v-model="deviceParams.deviceName" placeholder="请输入设备名称" clearable />
    </el-form-item>
    <el-form-item label="设备分类" prop="type">
      <el-select class="selectItem w" clearable v-model="deviceParams.type" placeholder="请选择设备分类">
        <el-option :label="item.name" :value="item.id" v-for="(item, index) in typeList" :key="index"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="设备图片" prop="deviceImg">
      <uploadImg :ImgUrl="deviceParams.deviceImg" @imgCallback="(url) => imgCallback(url, 'deviceImg')" > </uploadImg>
    </el-form-item>
    <el-form-item label="数据获取方式" prop="dataGet" required>
      <el-checkbox-group v-model="deviceParams.dataGet">
        <div>
          <el-checkbox label="2" :key="2">数据库接入</el-checkbox>
          <div class="formCont" v-if="deviceParams.dataGet.includes('2')">
            <div class="flex">
              <el-form-item label="数据库类型" prop="dataType" class="flx1">
                <el-select class="selectItem w" clearable v-model="deviceParams.dataType" placeholder="请选择设备分类">
                  <el-option :label="item.name" :value="item.value" v-for="item in dataTypeList" :key="item.value"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="主机" prop="ip" class="flx1">
                <el-input v-model="deviceParams.ip" placeholder="请输入主机名称" clearable />
              </el-form-item>
            </div>
            <div class="flex">
              <el-form-item label="端口" prop="port" class="flx1">
                <el-input v-model="deviceParams.port" placeholder="请输入端口" clearable />
              </el-form-item>
              <el-form-item label="数据库名称" prop="dataName" class="flx1">
                <el-input v-model="deviceParams.dataName" placeholder="请输入主机名称" clearable />
              </el-form-item>
            </div>
            <div class="flex">
              <el-form-item label="表名" prop="tableName" class="flx1">
                <el-input v-model="deviceParams.tableName" placeholder="请输入表名" clearable />
              </el-form-item>
              <el-form-item label="用户名" prop="userName" class="flx1">
                <el-input v-model="deviceParams.userName" placeholder="请输入用户名" clearable />
              </el-form-item>
            </div>
            <div class="flex">
              <div class="flx1">
                <el-form-item label="密码" prop="passWord">
                  <el-input v-model="deviceParams.passWord" placeholder="请输入密码" clearable />
                </el-form-item>
              </div>
              <div class="flx1">
              </div>
            </div>
          </div>
        </div>
        <div>
          <el-checkbox label="3" :key="3">蓝牙接入</el-checkbox>
          <div class="formCont ceshi" v-if="deviceParams.dataGet.includes('3')">
            <el-form-item label="接口文件" prop="dataGet">
              <a-upload :showUploadList="false" name="file" :multiple="true" :action="baseUrl + `/api/file/uploadOss`"
                :headers="headers" @change="blueFileChange">
                <a-button type="primary" size="small" class="uploadAButton">
                  <loading-outlined v-if="fileListLoading"></loading-outlined>
                  <upload-outlined v-else></upload-outlined>
                  <i class="el-icon-upload2"></i>
                  上传文件
                </a-button>
              </a-upload>
              <div class="fileList mt20">
                <div v-for="(item, index) in deviceParams.blueList" :key="index" class="fileItem">
                  <div class="iconCont">
                    <img
                      :title="item.fileName"
                      :src="require(`@/assets/file/file_type_excel.png`)"
                      class="icon"
                      v-if="item.contentType == '.xls' || item.contentType == '.xlsx'"
                    />
                    <img
                      :title="item.fileName"
                      :src="require(`@/assets/file/file_type_pdf.png`)"
                      class="icon"
                      v-if="item.contentType == '.pdf'"
                    />
                    <img
                      :title="item.fileName"
                      :src="require(`@/assets/file/file_type_word.png`)"
                      class="icon"
                      v-if="item.contentType == '.doc' || item.contentType == '.docx'"
                    />
                  </div>
                  <div class="flx1">
                    <div class="fileName">{{ item.fileName }}</div>
                    <div class="time">{{ item.time }}</div>
                  </div>
                  <div class="flex-s-c">
                    <el-link type="primary" @click="previewFile(item)">预览</el-link>
                    <el-popconfirm title="确定删除吗？该操作不会撤销" @confirm="handleDelete(index, 'blueList')" >
                      <i class="el-icon-close delete" slot="reference"></i>
                    </el-popconfirm>
                  </div>
                </div>
              </div>
            </el-form-item>
          </div>
        </div>
        <div>
          <el-checkbox label="1" :key="1">API接入</el-checkbox>
          <div class="formCont ceshi" v-if="deviceParams.dataGet.includes('1')">
            <el-form-item label="接口文件" prop="dataGet">
              <a-upload :showUploadList="false" name="file" :multiple="true" :action="baseUrl + `/api/file/uploadOss`"
                :headers="headers" @change="apiFileChange">
                <a-button type="primary" size="small" class="uploadAButton">
                  <loading-outlined v-if="fileListLoading"></loading-outlined>
                  <upload-outlined v-else></upload-outlined>
                  <i class="el-icon-upload2"></i>
                  上传文件
                </a-button>
              </a-upload>
              <div class="fileList mt20">
                <div v-for="(item, index) in deviceParams.apiList" :key="index" class="fileItem">
                  <div class="iconCont">
                    <img
                      :title="item.fileName"
                      :src="require(`@/assets/file/file_type_excel.png`)"
                      class="icon"
                      v-if="item.contentType == '.xls' || item.contentType == '.xlsx'"
                    />
                    <img
                      :title="item.fileName"
                      :src="require(`@/assets/file/file_type_pdf.png`)"
                      class="icon"
                      v-if="item.contentType == '.pdf'"
                    />
                    <img
                      :title="item.fileName"
                      :src="require(`@/assets/file/file_type_word.png`)"
                      class="icon"
                      v-if="item.contentType == '.doc' || item.contentType == '.docx'"
                    />
                  </div>
                  <div class="flx1">
                    <div class="fileName">{{ item.fileName }}</div>
                    <div class="time">{{ item.time }}</div>
                  </div>
                  <div class="flex-s-c">
                    <el-link type="primary" @click="previewFile(item)">预览</el-link>
                    <el-popconfirm title="确定删除吗？该操作不会撤销" @confirm="handleDelete(index, 'apiList')" >
                      <i class="el-icon-close delete" slot="reference"></i>
                    </el-popconfirm>
                  </div>
                </div>
              </div>
            </el-form-item>
          </div>
        </div>
        <div>
          <el-checkbox label="4" :key="4">EXCEL/CSV导入</el-checkbox>
        </div>
      </el-checkbox-group>

    </el-form-item> 
    <el-form-item label="设备厂商" prop="accessSource">
      <el-select class="selectItem w" clearable v-model="deviceParams.accessSource" placeholder="请选择设备厂商">
        <el-option :label="item.companyName" :value="item.id" v-for="(item, index) in accessSourceList" :key="index"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="设备详情" prop="remark">
      <Editor v-model="deviceParams.remark" @input="input"></Editor>
    </el-form-item>
    <el-form-item>
      <el-button type="default" @click="initFromData">重置</el-button>
      <el-button type="primary" @click="subimtFrom">保存</el-button>
    </el-form-item>

    <el-dialog
      title="文件预览"
      :visible.sync="showFile"
      close-on-click-modal
      fullscreen
      append-to-body
    >
      <FileViewer :path="fileUrl"></FileViewer>
    </el-dialog>
  </el-form>
</template>
<script>
import store from "@/store/index";
import moment from "moment";
import * as API_Ques from "@/api/dataAccess/accessApi";
import Editor from "@/components/Editor/editor";
import uploadImg from "@/components/uploadImg/uploadImg.vue";
import FileViewer from "@/components/common/fileViewer.vue";
export default {
  props: {
    componentsType: {
      type: String,
      default: "add",
    },
    deviceId: {
      type: String | Number,
      default: "",
    },
    activeKey: {
      type: String | Number,
      default: "",
    },
  },
  components: {
    Editor,
    uploadImg,
    FileViewer
  },
  data() {
    return {
      showModal: false,
      http: process.env.VUE_CONTEXT_PATH,
      baseUrl: process.env.VUE_APP_BASE_API,
      headers: {
        system: 0,
        token: store.state.token,
      },
      deviceParams: {
        deviceType: "1",
        deviceName: '',
        type: null,
        deviceImg: '',
        accessSource: undefined,
        remark: '',
        dataGet: [],

        dataType: null,
        ip: null,
        port: null,
        dataName: null,
        tableName: null,
        userName: null,
        passWord: null,

        blueList: [],
        apiList: []
      },
      rules: {
        deviceName: [ { required: true, message: "请输设备名称", trigger: "change" }, ],
        type: [ { required: true, message: "请选择设备分类", trigger: "change" }, ],
        deviceImg: [ { required: true, message: "请上传设备图片", trigger: "change" }, ],
        accessSource: [ { required: true, message: "请选择设备厂商", trigger: "change" }, ],
        dataGet: [ { required: true, message: "请选择数据获取方式", trigger: "change" }, ],
        remark: [ { required: true, message: "请输入设备详情", trigger: "blur" }, ],
        
        dataType: [ { required: true, message: "请选择数据库类型  ", trigger: "change" }, ],
        ip: [ { required: true, message: "请输入主机名称", trigger: "blur" }, ],
        port: [ { required: true, message: "请输入端口", trigger: "blur" }, ],
        dataName: [ { required: true, message: "请输入数据库名称", trigger: "blur" }, ],
        tableName: [ { required: true, message: "请输入表名", trigger: "blur" }, ],
        userName: [ { required: true, message: "请输入用户名", trigger: "blur" }, ],
        passWord: [ { required: true, message: "请输入密码", trigger: "blur" }, ],
      },
      
      typeList: [],
      dataGetList: [
        { value: "1", id: 0, name: "api", }, 
        { value: "2", id: 0, name: "数据库", },
        { value: "3", id: 0, name: "蓝牙", }, 
        { value: "4", id: 0, name: "EXCEL/CSV", },
      ],
      dataTypeList: [
        { value: "1", id: 0, name: "mYsql", }, 
        { value: "2", id: 0, name: "Sql server", }, 
        { value: "3", id: 0, name: "Oracle", }
      ],
      accessSourceList: [],
      requestList: [
        { value: "1", name: "get", }, 
        { value: "2", name: "post", }
      ],
      
      fileList: [],
      fileListColumns: [
        {
          title: "文件名",
          dataIndex: "fileName",
          key: "fileName",
          align: "center",
          width: 80,
        },
        {
          title: "上传时间",
          dataIndex: "time",
          key: "time",
          align: "center",
          width: 80,
        },
        {
          title: "操作",
          dataIndex: "action",
          key: "action",
          width: 200,
          align: "center",
          scopedSlots: {
            customRender: "action",
          },
        },
      ],
      fileListLoading: false,
      deviceImg: "",
      deviceImgLoading: false,
      detailsData: {},
      classificationVisible: false,
      showFile: false,
      fileUrl: '',
    };
  },
  watch: {
    deviceId: function () {
      this.init();
    },
    activeKey: function () {
      this.init();
    },
  },
  methods: {
    previewFile(item) {
      console.log(item);
      this.showFile  = true
      this.fileUrl = item.url
    },
    input(e) {
      this.$set(this.deviceParams, "details", e);
      this.$refs.deviceForm.clearValidate("details");
    },
    imgCallback(imgUrl, key) {
      this.$nextTick(() => {
        this.$set(this.deviceParams, key, imgUrl);
      });
    },
    deviceTypeChange(dType) {
      if (this.deviceType == dType) {
        return false;
      }
      this.deviceType = dType;
      console.log(this.deviceType);
    },
    // 文件下载
    downloadFun(row) {
      location.href = row.url;
    },
    // 文件列表删除一项
    handleDelete(index,key) {
      const list = this.deviceParams[key];
      list.splice(index, 1);
      this.deviceParams[key] = list;
    },
    // 接口文件上传
    fileListChange(info) {
      console.log(info);
      if (info.file.status === "uploading") {
        this.fileListLoading = true;
        return;
      }
      if (info.file.status === "done") {
        this.fileListLoading = false;
        const res = info.file.response;
        if (res.code == 200) {
          const list = this.fileList || [];
          res.data.time = moment(res.data.time).format("YYYY-MM-DD");
          list.push(res.data);
          this.fileList = list;
        }
      }

      if (info.file.status === "error") {
        this.fileListLoading = false;
        this.$message.error("上传失败");
      }
    },
    blueFileChange(info) {
      console.log(info);
      if (info.file.status === "uploading") {
        this.fileListLoading = true;
        return;
      }
      if (info.file.status === "done") {
        this.fileListLoading = false;
        const res = info.file.response;
        if (res.code == 200) {
          const list = this.deviceParams.blueList || [];
          res.data.time = moment(res.data.time).format("YYYY-MM-DD HH:mm");
          list.push(res.data);
          this.deviceParams.blueList = list;
        }
      }

      if (info.file.status === "error") {
        this.fileListLoading = false;
        this.$message.error("上传失败");
      }
    },
    apiFileChange(info) {
      console.log(info);
      if (info.file.status === "uploading") {
        this.fileListLoading = true;
        return;
      }
      if (info.file.status === "done") {
        this.fileListLoading = false;
        const res = info.file.response;
        if (res.code == 200) {
          const list = this.deviceParams.apiList || [];
          res.data.time = moment(res.data.time).format("YYYY-MM-DD HH:mm");
          list.push(res.data);
          this.deviceParams.apiList = list;
          // console.log(this.deviceParams.apiList);
        }
      }

      if (info.file.status === "error") {
        this.fileListLoading = false;
        this.$message.error("上传失败");
      }
    },
    deviceImgChange(info) {
      console.log(info);
      if (info.file.status === "uploading") {
        this.deviceImgLoading = true;
        return;
      }
      if (info.file.status === "done") {
        this.deviceImgLoading = false;
        const res = info.file.response;
        if (res.code == 200) {
          this.deviceImg = res.data.url;
        }
      }

      if (info.file.status === "error") {
        this.deviceImgLoading = false;
        this.$message.error("上传失败");
      }
    },
    getData() {
      let param = { system: 1 };
      API_Ques.getCompanyList(param).then((res) => {
        const { code, data, msg } = res;
        if (code == 0 || code == 200) {
          console.log(data);
          this.accessSourceList = data;
          // this.pagination.total = data.total * 1;
          return false;
        }
        this.$message.error(msg || "接口异常，请联系管理员");
      });
    },
    // 表格重置
    initFromData() {
      this.$refs.deviceForm.resetFields();
      this.deviceParams.dataGet = []
      this.deviceParams.apiList = []
      this.deviceParams.blueList = []
      // console.log(this.deviceParams);
    },
    // 表单添加
    subimtFrom() {
      // console.log(this.deviceParams);
      this.$refs["deviceForm"].validate((valid) => {
        if (valid) {
          console.log("onSubmit");
          let {
            deviceType,deviceName,type,deviceImg,accessSource,remark,dataGet,
            dataType,ip,port,dataName,tableName,userName,passWord,
            blueList,apiList
          } = this.deviceParams
          let common = {
            deviceType,deviceName,type,deviceImg,accessSource,remark,
          }
          let params = {
            deviceType,type,deviceName,deviceImg,accessSource,remark
          }
          let appDeviceInfoList = []
          for (let i = 0; i < dataGet.length; i++) {
            const ele = dataGet[i];
            let obj = {
              ...common,
              dataGet: ele
            }
            if(ele == '2') {
              obj = {
                ...obj,
                dataType,ip,port,dataName,tableName,userName,passWord
              }
            }
            if(ele == '3') {
              obj = {
                ...obj,
                portFile: JSON.stringify(blueList)
              }
            }
            if(ele == '1') {
              obj = {
                ...obj,
                portFile: JSON.stringify(apiList)
              }
            }
            appDeviceInfoList.push(obj)
          }
          params.appDeviceInfoList = appDeviceInfoList
          // console.log(params);
          this.adddeviceFieFun(params);
        } else {
          this.$message({
            message: "填写数据不全或数据有误",
            type: "error",
          });
          return false;
        }
      });
    },
    handleOk(e) {
      this.fromDom.validateFieldsAndScroll((errors, values) => {
        if (!errors) {
          this.showModal = false;
          this.editdeviceFieFun(values);
        }
      });
    },
    // 新增
    adddeviceFieFun(body) {
      API_Ques.deviceAdd(body).then((res) => {
        const { code, msg } = res;
        if (code == 0 || code == 200) {
          this.$message.success("添加成功！");
          this.initFromData();
          this.$emit("submit");
          return false;
        }
        this.$message.error(msg || "接口异常，请联系管理员");
      });
    },
    // 编辑
    editdeviceFieFun(body) {
      API_Ques.editdeviceFie({
        ...this.detailsData,
        portFile: JSON.stringify(this.fileList),
        ...body,
      }).then((res) => {
        const { code, msg } = res;
        if (code == 0 || code == 200) {
          this.$message.success("操作成功！");
          this.$emit("init");
          return false;
        }
        this.$message.error(msg || "接口异常，请联系管理员");
      });
    },
    // 接入配置详情
    findDeviceInfoFun() {
      API_Ques.findDeviceInfo({
        deviceId: this.deviceId,
      }).then((res) => {
        // console.log(res);
        const { code, msg, data } = res;
        if (code == 0 || code == 200) {
          const { deviceType, portFile, dataGet } = data;
          this.fileList = portFile ? JSON.parse(portFile) : [];
          this.deviceType = deviceType;
          this.deviceImg = data.deviceImg;
          this.detailsData = data;
          this.fromDom.setFieldsValue({
            dataGet,
          });
          return false;
        }
        this.$message.error(msg || "接口异常，请联系管理员");
      });
    },
    // 获取分类列表
    getListDeviceType() {
      API_Ques.listDeviceType({}).then((res) => {
        const { code, msg, data } = res;
        if (code == 0 || code == 200) {
          this.typeList = data;
          return;
        }
        this.$message.error(msg || "接口异常，请联系管理员");
      });
    },
    _getDataGets() {
      API_Ques.getDataGets({deviceId: 58}).then((res) => {
        const { code, msg, data } = res;
        console.log(res);
        let getArr = []
        if(res && res.length) {
          for (let i = 0; i < res.length; i++) {
            const data = res[i];
            getArr.push(data.dataGet)
            if(data.dataGet == '2') {
              let { dataType,ip,port,dataName,tableName,userName,passWord } = data
              this.deviceParams = {
                ...this.deviceParams,
                dataType,ip,port,dataName,tableName,userName,passWord
              }
            }
            if(data.dataGet == '3') {
              let { portFile } = data
              this.deviceParams = {
                ...this.deviceParams,
                blueList: JSON.parse(portFile)
              }
            }
            if(data.dataGet == '1') {
              let { portFile } = data
              this.deviceParams = {
                ...this.deviceParams,
                apiList: JSON.parse(portFile)
              }
            }
          }
          this.deviceParams.dataGet = getArr
          console.log(this.deviceParams);
        }
      });
    },
    // 关闭分类管理弹窗
    classificationCancel() {
      this.classificationVisible = false;
      this.deviceForm.resetFields(["type"]);
      this.getListDeviceType();
      // 刷新分类管理下拉框列表
    },
    init() {
      this.getData();
      this.getListDeviceType();
      if (this.componentsType == "edit") {
        let info = JSON.parse(localStorage.getItem('deviceInfo'))
        this.deviceParams = info
        this._getDataGets()
      }
    },
  },
  created() {
    this.init()
  },
};
</script>
<style scoped lang="less">
.deviceForm {
  max-height: 75vh;
  overflow-y: auto;
}
.formCont {
  padding: 18px 18px 1px 18px;
  border-radius: 6px;
  color: #fff;
  font-size: 14px;
  background-color: #1D233D;
}
.fileItem {
  display: flex;
  align-items: center;
  padding: 12px;
  border-radius: 8px;
  line-height: 24px;
  .iconCont {
    width: 48px;
    height: 48px;
    margin-right: 8px;
  }
  .icon {
    width: 100%;
    height: 100%;
  }
  .delete {
    display: none;
    width: 20px;
    height: 20px;
    margin-left: 10px;
    border-radius: 50%;
    color: #409EFF;
    font-size: 12px;
    line-height: 20px;
    text-align: center;
    background-color: #ddd;
  }
  &:hover {
    background-color: #505879;
    .delete {
      display: block;
    }
  }
}
.title {
  position: relative;
  padding-left: 16px;
}

.title::after {
  content: " ";
  background: #1890ff;
  width: 3px;
  height: 12px;
  position: absolute;
  left: 0;
  top: 6px;
}

.deviceTypeBox {
  display: flex;
  align-items: center;

  >div {
    background: #21284b;
    font-size: 13px;
    border-radius: 60px;
    color: #bcbcbc;
    width: 120px;
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    &:nth-of-type(1) {
      margin-right: 40px;
    }
  }

  .av {
    color: #1890ff;
    border: 1px solid #1890ff;
    background: transparent;
  }
}

.ceshi {
  .ant-form-item {
    margin: 0 !important;
  }
}

.ceshi {
  .ant-upload {
    .uploadAButton {
      background-color: #1890ff !important;
      color: #fff !important;
      height: 32px;
      line-height: 32px;      

      &:hover {
        opacity: .7;
      }
    }
  }
}
</style>